// MP900 — the Vulnerabilities dashboard moved into X-One Exposure.
// Old addresses forward to the new ones; App.tsx appends the query and
// hash, so shared filtered links keep working.

/** Old address → new address, longest prefix first. */
export const EXPOSURE_LEGACY_ROUTES: ReadonlyArray<readonly [string, string]> = [
  ['/dashboards/vulnerabilities/findings', '/exposure/findings'],
  ['/dashboards/vulnerabilities', '/exposure'],
];

/** Where an old Vulnerabilities address now lives, or the path unchanged. */
export function exposureLegacyTarget(pathname: string): string {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  for (const [from, to] of EXPOSURE_LEGACY_ROUTES) {
    if (path === from) return to;
  }
  return pathname;
}
